import indent from 'indent-string';
import mustache from 'mustache';
import stringifyObject from 'stringify-object';
import qs from 'qs';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var languages = [{
  language: 'bash',
  label: 'cURL',
  templateGET: "curl {{#hasFileOutput}}-o '{{output}}' {{/hasFileOutput}}\\\n  '{{{service.url}}}?{{{exampleQuery}}}'{{#token}} \\\n  -H 'authorization: {{token}}'{{/token}}\n",
  templatePOST: "curl -X POST{{#hasFileOutput}} -o '{{output}}'{{/hasFileOutput}} \\\n  '{{{service.url}}}' \\\n  -H 'content-type: application/json' \\\n{{#token}}  -H 'authorization: {{token}}' \\\n{{/token}}  -d '{{{exampleJSONPretty}}}'\n"
}, {
  language: 'javascript',
  label: 'Node.js',
  templateGET: "const request = require('request')\nconst fs = require('fs')\n\nconst options = {\n  url: '{{{service.url}}}',{{#token}}\n  headers: {\n    'authorization': '{{token}}'\n  },{{/token}}\n  qs: {{{examplJSONBareIndented}}},\n  json: true{{#hasFileOutput}},\n  encoding: null{{/hasFileOutput}}\n}\n\nrequest(options, (error, response, body) => {\n  if (error) throw new Error(error)\n\n  {{#hasFileOutput}}fs.writeFileSync('{{output}}', body){{/hasFileOutput}}{{^hasFileOutput}}console.log(body){{/hasFileOutput}}\n})\n",
  templatePOST: "const request = require('request')\nconst fs = require('fs')\n\nconst options = {\n  method: 'POST',\n  url: '{{{service.url}}}',\n  headers: {\n    'content-type': 'application/json'{{#token}},\n    'authorization': '{{token}}'{{/token}}\n  },\n  body: {{{exampleJSONBareIndented}}},\n  json: true{{#hasFileOutput}},\n  encoding: null{{/hasFileOutput}}\n}\n\nrequest(options, (error, response, body) => {\n  if (error) throw new Error(error)\n\n  {{#hasFileOutput}}fs.writeFileSync('{{output}}', body){{/hasFileOutput}}{{^hasFileOutput}}console.log(body){{/hasFileOutput}}\n})\n"
}, {
  language: 'python',
  label: 'Python',
  templatePOST: "import requests\n\nurl = \"{{{service.url}}}\"\npayload = {{{exampleJSON}}}\nresponse = requests.post(url, json=payload)\n\n{{#hasFileOutput}}\nwith open(\"{{output}}\", \"wb\") as out:\n    out.write(response.content)\n{{/hasFileOutput}}{{^hasFileOutput}}\nprint(response.text)\n{{/hasFileOutput}}\n"
}, {
  language: 'go',
  label: 'Go',
  templatePOST: "package main\n\nimport (\n\t\"bytes\"\n\t\"encoding/json\"\n\t\"io\"\n\t\"net/http\"\n\t\"os\"\n)\n\nfunc main() {\n\tmessage := map[string]interface{}{\n\t\t{{{exampleJSON}}},\n\t}\n\n\tbytesRepresentation, _ := json.Marshal(message)\n\n\tresp, _ := http.Post(\"{{{service.url}}}\", \"application/json\", bytes.NewBuffer(bytesRepresentation))\n\n{{#hasFileOutput}}\n\tout, _ := os.Create(\"{{output}}\")\n\n\t_, _ = io.Copy(out, resp.Body)\n{{/hasFileOutput}}{{^hasFileOutput}}\n\tout, _ := os.Create(\"result.json\")\n\n\t_, _ = io.Copy(out, resp.Body)\n{{/hasFileOutput}}\n}\n"
}];

var index = function index(service, token, opts) {
  if (opts === void 0) {
    opts = {};
  }

  var _opts = opts,
      _opts$method = _opts.method,
      method = _opts$method === void 0 ? 'POST' : _opts$method,
      _opts$example = _opts.example,
      example = _opts$example === void 0 ? service.examples[0] : _opts$example;

  if (method !== 'POST' && method !== 'GET') {
    throw new Error("Service codegen is not supported for method \"" + method + "\"");
  }

  if (!example) {
    console.warn("Codegen received empty example for service \"" + service.name + "\"");
    return;
  }

  var data = {
    service: service,
    token: token
  };
  data.exampleQuery = qs.stringify(example.input);
  data.exampleJSON = JSON.stringify(example.input);
  data.exampleJSONPretty = JSON.stringify(example.input, null, 2);
  data.exampleJSONBare = stringifyObject(example.input, {
    indent: '  '
  });
  data.exampleJSONBareIndented = indent(data.exampleJSONBare, 1, {
    indent: '  '
  }).slice(2);
  data.hasFileOutput = !!example.outputUrl;
  data.output = example.output;
  var snippets = example.snippet && example.snippet.exclusive ? [example.snippet] : languages.map(function (l) {
    var template = l["template" + method];

    if (template) {
      var code = mustache.render(template, data).trim();
      var language = l.language,
          label = l.label;
      return {
        code: code,
        language: language,
        label: label
      };
    }
  }).filter(Boolean);

  if (example.snippet && !example.snippet.exclusive) {
    snippets = [example.snippet].concat(snippets);
  }

  return _extends({}, example, {
    hasFileOutput: data.hasFileOutput,
    snippets: snippets
  });
};

export default index;